// extracted by mini-css-extract-plugin
export default {"container":"starIconOrder_container__Te73m","icon":"starIconOrder_icon__SOgMF","img":"starIconOrder_img__5pvA2","number":"starIconOrder_number__WwQxQ"};